import { Select } from 'antd';

export const CallVolumes = [...Array(5).keys()].reduce((prev, curr) => {
  const v = curr + 1;
  prev[v] = {
    key: v,
    label: `${v}`,
  };
  return prev;
}, {});

function SelectCallVolume({ value, onChange, ...other }) {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder="Select a call volume"
      allowClear
      {...other}
    >
      {Object.values(CallVolumes).map((v) => (
        <Select.Option key={v.key} value={v.key}>
          {v.label}
        </Select.Option>
      ))}
    </Select>
  );
}

export default SelectCallVolume;
